import LazyLoad from "vanilla-lazyload";


const ShortVideoHero = {
  render: function () {
    const wrapEl = $(".main-hero-item--video-slider");
    const prevBtn = wrapEl.find(".swiper-nav-button--prev");
    const nextBtn = wrapEl.find(".swiper-nav-button--next");

    wrapEl.find(".short-video .short-video__main").each(function () {
      const videoId = $(this).attr("id");
      const playlistId = $(this).attr("playlist-id");

      if (videoId !== "") {

        const player = new YT.Player(videoId, {
          videoId: videoId,
          width: 376,
          height: 700,
          playerVars: {
            autoplay: 0,
            controls: 1,
            start: 0,
            rel: 0,
            fs: 0,
            cc_load_policy: 0,
            iv_load_policy: 3,
            mute: 0,
          },
          events: {
            onReady: function () {
              player.seekTo(0).stopVideo();
            },
          },
        }
        );

        prevBtn.on("click", function () {
          player.stopVideo();
        })

        nextBtn.on("click", function () {
          player.stopVideo();
        });

      } else {
        const videoWrapEl = $(this);
        const video = videoWrapEl.find('video')[0];
        const playControls = videoWrapEl.find(".short-video__player-controls");

        // To force video layout reflow to get controls in correct dimensions
        videoWrapEl.find('video').on("loadedmetadata", function () {
          video.style.display = 'none';
          void video.offsetHeight; // Trigger reflow
          video.style.display = 'block';
        });

        new LazyLoad.load(
          video,
          {
            callback_loaded: function () {
              videoWrapEl.addClass('ready');

            }
          },

          playControls.on("click", function () {
            video.play();
            videoWrapEl.addClass("playing");
          })
        );

        prevBtn.on("click", function () {
          video.pause();
          if (videoWrapEl.hasClass("playing")) {
            videoWrapEl.removeClass("playing");
          }
        })

        nextBtn.on("click", function () {
          video.pause();
          if (videoWrapEl.hasClass("playing")) {
            videoWrapEl.removeClass("playing");
          }
        });
      }
    });
  },
};

export default ShortVideoHero;